import { Box, Tooltip, Typography } from "@mui/material";
import { Clear } from "@mui/icons-material";
import { useEffect, useState } from "react";
import GridArrow from "components/Unit/GridArrow";

// image imports
import play from "images/dashboard/play.svg";
import battery from "images/dashboard/battery.svg";
import batteryFull from "images/dashboard/batteryFull.svg";
import grid from "images/dashboard/grid.svg";
import solar from "images/dashboard/solar.svg";
import solarHallow from "images/dashboard/solar_hallow.svg";
import thermostat from "images/dashboard/thermostat.svg";
import storage from "images/dashboard/storage.svg";
import memory from "images/dashboard/memory.svg";

const iconMap = {
  operation: play,
  grid,
  solar,
  solarHallow,
  battery,
  batteryFull,
  temp: thermostat,
  memory,
  storage,
};

const SiteStatusIcon = ({
  type,
  value1,
  value2,
  tooltips = [],
  width = "70px",
  status,
}) => {
  const [message, setMessage] = useState("");
  const [nVal, setNVal] = useState(0);
  const [gridDisconnected, setGridDisconnected] = useState(false);
  const isOperation = type === "operation";

  useEffect(() => {
    if (value2 && type === "grid") {
      setNVal(Number(value2.replaceAll("kW", "")));
    }
  }, [value2]);

  useEffect(() => {
    if (tooltips.length > 0) setMessage(tooltips.join("\n"));
  }, [tooltips]);

  useEffect(() => {
    if (type !== "grid" || !status) return;

    if (!status.grid_connected) {
      setGridDisconnected(true);
      setMessage("Disconnected from grid");
    } else if (!status.grid_present) {
      setMessage("Grid not available");
    } else {
      setGridDisconnected(false);
      setMessage("Grid Voltage\nGrid Power");
    }
  }, [status, type]);

  const Icon = iconMap[type] ?? play;

  return (
    <Tooltip
      title={
        message && <span style={{ whiteSpace: "pre-line" }}>{message}</span>
      }
      placement="top"
      arrow
    >
      <Box
        className="items-center flex-end status-icon"
        mr={2}
        my={0.5}
        sx={{ minWidth: width }}
      >
        <Box className="items-center flex-grow" sx={{ position: "relative" }}>
          {type !== "noop" && <img src={Icon} alt={type} />}

          {type === "grid" && !status?.grid_present && (
            <Box
              sx={{
                position: "absolute",
                top: "-10px",
                left: "6px",
                fontSize: "30px",
                transform: "rotate(45deg)",
              }}
            >
              /
            </Box>
          )}
        </Box>

        {type === "grid" && (
          <Box
            sx={{
              width: "16px",
              height: "35px",
              display: "flex",
              alignItems: "flex-end",
              mt: "2px",
            }}
          >
            {gridDisconnected ? (
              <Clear sx={{ fontSize: "16px", color: "red" }} />
            ) : (
              nVal !== 0 && <GridArrow positive={nVal > 0} />
            )}
          </Box>
        )}

        <Box className={`flex flex-col ${isOperation ? "" : "align-end"}`}>
          <Typography fontSize="13px" fontWeight={isOperation ? "500" : "400"}>
            {value1}
          </Typography>
          <Typography fontSize={isOperation ? "12px" : "13px"} lineHeight={1}>
            {value2}
          </Typography>
        </Box>
      </Box>
    </Tooltip>
  );
};

export default SiteStatusIcon;
